module.exports = __webpack_public_path__ + "img/icon_weather_111.f6412db8.svg";